export const SET_JOBS = 'SET_JOBS';
export const SET_JOBS_LOADING = 'SET_JOBS_LOADING';